import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import moment from 'moment';
import { MovementPlanService } from '../services/movements/movement-plan.service';
import { FilterMovementPlan } from '../models/dtos/movements/filter-movement-plan';
import { MovementPlanDTO } from '../models/dtos/movements/movement-plan-dto';
import { MovementPlanStatus } from '../models/enums/movements/movement-plan-status';
import { PaginationFilter } from '../models/pagination-filter';

/** Mensagem da trava do legado (api1 MovementPlanServiceImpl.verifyIfCanCreateMovementPlanToBoat, BUG-1063). */
export const OPEN_PLAN_TODAY =
  'Já existe um plano de movimentação ativo para esta embarcação no dia selecionado. Use a tela de Movimentação.';

const CLOSED_STATUSES: string[] = [MovementPlanStatus.CANCELED, MovementPlanStatus.FINISHED];

/**
 * EM-2589: plano ABERTO (status fora de CANCELED/FINISHED) do barco com saída no dia informado, pela busca da tela de
 * planos (POST /secure/movement-plan/movement-plan-by-filter, MovementPlanQueryController.byFilter). É a mesma regra
 * do legado para recusar um segundo plano do barco no mesmo dia; o mapa não cria plano quando ela acusa um.
 */
export function findOpenPlanOfDay(
  movementPlanService: MovementPlanService,
  boatId: number,
  day: Date = new Date()
): Observable<MovementPlanDTO | null> {
  const date = moment(day).format('YYYY-MM-DD');
  const filter: FilterMovementPlan = { boatId, executionDateStart: date, executionDateEnd: date };
  const pagination = new PaginationFilter();
  pagination.page = 0;
  pagination.size = 0;
  pagination.sort = 'id';
  pagination.order = 'DESC';
  return movementPlanService.getMovementPlans(filter, pagination).pipe(
    map((plans) => (plans || []).find((plan) => plan && !CLOSED_STATUSES.includes(plan.movementPlanStatus)) || null)
  );
}
